module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-8-svgrepo-com.01ffde88.svg";